import React, { useState } from "react";
import { Card } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiShoppingCart, FiClock, FiTag } from "react-icons/fi";
import CustomModal from "./Modal.js";

const PackageCard = ({ packageData }) => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <Card className="oglitz-package-card">
        {/* IMAGE */}
        <div className="oglitz-package-image-wrap">
          <img
            src={packageData.logo}
            alt={packageData.title}
            className="oglitz-package-image"
          />
        </div>

        {/* CONTENT */}
        <div className="oglitz-package-content">
          <h3 className="oglitz-package-title">{packageData.title}</h3>

          <div className="oglitz-package-meta">
            <span>
              <FiTag /> ₹{packageData.price}
            </span>
            <span>
              <FiClock /> {packageData.duration}
            </span>
          </div>

          <p className="oglitz-package-description">
            {packageData.description}
          </p>
        </div>

        {/* ACTIONS */}
        <div className="oglitz-package-actions">
          <Link to={packageData.link} className="oglitz-package-link">
            <FiArrowRight />
            View Details
          </Link>

          <button
            className="oglitz-package-cta"
            onClick={() => setModalShow(true)}
          >
            <FiShoppingCart />
            Order Now
          </button>
        </div>
      </Card>

      <CustomModal
        isOpen={modalShow}
        onRequestClose={() => setModalShow(false)}
        modalData={packageData}
      />
    </>
  );
};

export default PackageCard;
